import { TimesheetModel } from '../../models/models';

/**
 * Ordina le registrazioni per data decrescente (più recente prima)
 */
export const ordinaRegistrazioni = (registrazioni: TimesheetModel[]): TimesheetModel[] => {
  return [...registrazioni].sort((a, b) => {
    const dataA = new Date(a.data_ingresso);
    const dataB = new Date(b.data_ingresso);
    return dataB.getTime() - dataA.getTime();
  });
};

/**
 * Calcola le ore lavorate tra un orario di inizio e fine
 * Gestisce automaticamente i turni notturni (quando fine < inizio)
 */
export const calcolaOre = (inizio: string, fine: string): string => {
  const [oreInizio, minInizio] = inizio.split(':').map(Number);
  const [oreFine, minFine] = fine.split(':').map(Number);
  const minutiInizio = oreInizio * 60 + minInizio;
  let minutiFine = oreFine * 60 + minFine;
  
  // Se è un turno notturno, aggiungi 24 ore (1440 minuti)
  if (minutiFine < minutiInizio) {
    minutiFine += 1440;
  }
  
  const differenza = minutiFine - minutiInizio;
  const ore = Math.floor(differenza / 60);
  const minuti = differenza % 60;
  return `${ore}h ${minuti.toString().padStart(2, '0')}m`;
};

/**
 * Calcola il totale delle ore lavorate da un array di registrazioni
 * Gestisce automaticamente i turni notturni
 */
export const calcolaTotaleOre = (registrazioni: TimesheetModel[]): string => {
  let totaleMinuti = 0;
  
  registrazioni.forEach(r => {
    const [oreInizio, minInizio] = r.oraInizio.split(':').map(Number);
    const [oreFine, minFine] = r.oraFine.split(':').map(Number);
    const minutiInizio = oreInizio * 60 + minInizio;
    let minutiFine = oreFine * 60 + minFine;
    
    // Se è un turno notturno, aggiungi 24 ore (1440 minuti)
    if (minutiFine < minutiInizio) {
      minutiFine += 1440;
    }
    
    totaleMinuti += minutiFine - minutiInizio;
  });
  
  const ore = Math.floor(totaleMinuti / 60);
  const minuti = totaleMinuti % 60;
  return `${ore}h ${minuti.toString().padStart(2, '0')}m`;
};

/**
 * Valida che l'ora di fine sia successiva all'ora di inizio
 */
export const validaOrari = (oraInizio: string, oraFine: string): boolean => {
  return oraFine > oraInizio;
};

/**
 * Calcola la data di uscita corretta per turni notturni
 * Se l'ora di fine è precedente all'ora di inizio, aggiunge un giorno
 */
export const calcolaDataUscita = (dataInizio: string, oraInizio: string, oraFine: string): string => {
  const [oreInizio, minInizio] = oraInizio.split(':').map(Number);
  const [oreFine, minFine] = oraFine.split(':').map(Number);
  const minutiInizio = oreInizio * 60 + minInizio;
  const minutiFine = oreFine * 60 + minFine;
  
  // Se è un turno notturno (fine < inizio), aggiungi un giorno
  if (minutiFine < minutiInizio) {
    const [anno, mese, giorno] = dataInizio.split('-').map(Number);
    const dataUscita = new Date(anno, mese - 1, giorno + 1);
    const year = dataUscita.getFullYear();
    const month = String(dataUscita.getMonth() + 1).padStart(2, '0');
    const day = String(dataUscita.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  return dataInizio;
};

/**
 * Formatta una data in formato italiano
 */
export const formattaDataItaliana = (data: string): string => {
  return new Date(data + 'T00:00:00').toLocaleDateString('it-IT', { 
    weekday: 'short', 
    day: 'numeric', 
    month: 'short' 
  });
};
